<template>
  <section>
    <div>
      <form ref="form" @submit.stop.prevent="filterOrders">
        <section>
          <br />
          <b-row>
            <b-col md="1" />
            <b-col cols="3">
              <b-form-group label-for="payment-option">
                <h5>Payment option</h5>

                <b-form-select
                  id="merchantId"
                  v-model="filterFopId"
                  :options="paymentOptions"
                />
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group>
                <h5>Paid Date Range</h5>
                <flat-pickr
                  v-model="trxnDateRange"
                  class="form-control"
                  :config="{ mode: 'range', maxDate: 'today' }"
                />
              </b-form-group>
            </b-col>
            <b-col md="1" />
            <b-col md="1">
              <b-button
                variant="primary"
                type="submit"
                @click.prevent="filterOrders"
              >
                Filter
              </b-button>
            </b-col>
            <b-col md="1" />

            <b-col md="1">
              <section>
                <xlsx-workbook>
                  <xlsx-sheet
                    v-for="sheet in sheets"
                    :key="sheet.name"
                    :collection="sheet.data"
                    :sheet-name="sheet.name"
                  />
                  <xlsx-download>
                    <button type="button" class="button btn-primary">
                      <feather-icon icon="DownloadCloudIcon" /> Export To Excel
                    </button>
                  </xlsx-download>
                </xlsx-workbook>
              </section>
            </b-col>
          </b-row>
        </section>
      </form>
    </div>

    <section>
      <b-row class="match-height">
        <b-col md="12">
          <financialsummary :data="trasactionReport" />
        </b-col>
      </b-row>

      <b-row class="match-height">
        <b-col lg="5" md="5">
          <successRate :data="trendReports" />
        </b-col>

        <b-col lg="7" md="7">
          <transactionsummary :data="transactionTracker" />
        </b-col>
      </b-row>
    </section>
    <b-row class="match-height">
      <vue-good-table
        :columns="columns"
        :rows="trendReports"
        :rtl="direction"
        :search-options="{
          enabled: false,
          externalQuery: searchTerm,
        }"
        :pagination-options="{
          enabled: false,
          perPage: pageLength,
        }"
      >
        <template slot="table-row">
          <!-- pagination -->
          <template slot="pagination-bottom" slot-scope="props">
            <div class="d-flex justify-content-between flex-wrap">
              <div class="d-flex align-items-center mb-0 mt-1">
                <span class="text-nowrap"> Showing 1 to </span>
                <b-form-select
                  v-model="pageLength"
                  :options="['5', '10', '15', '30', '50']"
                  class="mx-1"
                  @input="
                    (value) => props.perPageChanged({ currentPerPage: value })
                  "
                />
                <span class="text-nowrap"> of {{ props.total }} entries </span>
              </div>
              <div>
                <b-pagination
                  :value="1"
                  :total-rows="props.total"
                  :per-page="pageLength"
                  first-number
                  last-number
                  align="right"
                  prev-class="prev-item"
                  next-class="next-item"
                  class="mt-1 mb-0"
                  @input="(value) => props.pageChanged({ currentPage: value })"
                >
                  <template #prev-text>
                    <feather-icon icon="ChevronLeftIcon" size="18" />
                  </template>
                  <template #next-text>
                    <feather-icon icon="ChevronRightIcon" size="18" />
                  </template>
                </b-pagination>
              </div>
            </div>
          </template>
        </template>
      </vue-good-table>
    </b-row>
    <!-- loadings -->
    <b-overlay :show="isLoading" no-wrap rounded="sm" />
  </section>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormSelect,
  BButton,
  BOverlay,
} from "bootstrap-vue";
import axios from "@axios";
import { VueGoodTable } from "vue-good-table";
import flatPickr from "vue-flatpickr-component";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import {
  XlsxWorkbook,
  XlsxSheet,
  XlsxDownload,
} from "../../../node_modules/vue-xlsx/dist/vue-xlsx.es.js";
import financialsummary from "./transaction-report/financial-summary.vue";
import transactionsummary from "./transaction-report/transaction-summary.vue";
import successRate from "./transaction-report/success-rate.vue";

export default {
  components: {
    VueGoodTable,
    flatPickr,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BButton,
    BOverlay,
    XlsxWorkbook,
    XlsxSheet,
    XlsxDownload,
    financialsummary,
    transactionsummary,
    successRate,
  },
  props: {
    tableData: {
      type: Object,
      default: () => [],
    },
  },

  data() {
    return {
      columns: [
        {
          label: "Merchant",
          field: "merchant",
        },
        {
          label: "Payment Option Name",
          field: "paymentOptionName",
        },
        {
          label: "Total Collection",
          field: "totalCollection",
        },
        {
          label: "Net Collection",
          field: "netCollection",
        },
        {
          label: "Commission Fee",
          field: "commissionFee",
        },
        {
          label: "No Of Transaction",
          field: "noOfTransaction",
        },
        {
          label: "No Of Pending Transaction",
          field: "noOfPendingTransaction",
        },
        {
          label: "No Of Cancel Transaction",
          field: "noOfCancelTransaction",
        },
        {
          label: "No Of Other Transaction",
          field: "noOfOtherTransaction",
        },
        {
          label: "No Of Successful Transaction",
          field: "noOfSuccessfulTransaction",
        },
        {
          label: "Success Rate",
          field: "successRate",
        },
      ],
      sheets: [{ name: "Transactions Report", data: [] }],
      transactionTracker: {
        title: "Transaction Summary",
        lastDays: ["Last Month"],
        total: 0,
        successful: 0,
        pending: 0,
        cancelled: 0,
        other: 0,
        transTrackerRadialBar: {
          series: [0],
        },
      },
      trendReports: [],
      trasactionReport: {
        netCollection: 0,
        totalCollection: 0,
        commissionFee: 0,
      },
      paymentOptions: [{ value: 0, text: "--select Payment Option--" }],
      pageLength: 5,
      orderDateRange: "",
      trxnDateRange: "",
      filterFopId: 0,
      isLoading: false,
    };
  },
  created() {
    this.fetchData();
    this.fetchallPaymentOptions();
  },
  methods: {
    fetchData() {
      const d = new Date();
      let month = `${d.getMonth() + 1}`;
      let day = `${d.getDate()}`;
      const year = d.getFullYear();

      if (month.length < 2) {
        month = `0${month}`;
      }
      if (day.length < 2) {
        day = `0${day}`;
      }

      this.trxnStartDate = [year, month, day].join("-");
      this.trxnEndDate = [year, month, day].join("-");

      const url = `/Order/api/V1.0/Report/GetTrasactionTrendReport?transactionStartDate=${this.trxnStartDate}&transactionEndDate=${this.trxnEndDate}&paymentOptionId=${this.filterFopId}`;
      // Api call
      this.isLoading = true;
      axios
        .get(url)
        .then((res) => {
          this.sheets[0].data = [];
          this.dataFiltered = true;
          this.trendReports = res.groupedOrdersReport;
          this.trasactionReport = res.trendReport;
          this.transactionTracker.total = res.trendReport.noOfTransaction;
          this.transactionTracker.successful =
            res.trendReport.noOfSuccessfulTransaction;
          this.transactionTracker.pending =
            res.trendReport.noOfPendingTransaction;
          this.transactionTracker.cancelled =
            res.trendReport.noOfCancelTransaction;
          this.transactionTracker.other = res.trendReport.noOfOtherTransaction;
          this.transactionTracker.transTrackerRadialBar.series[0] =
            res.trendReport.successRate;
          this.sheets[0].data = res.groupedOrdersReport;

          this.isLoading = false;
          this.trxnEndDate = "";
          this.trxnStartDate = "";
        })
        .catch((res) => {
          this.isLoading = false;

          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Error",
              icon: "BellIcon",
              variant: "danger",
              text: `${res.data.message}`,
            },
          });
          // this.$refs.loginForm.setErrors(error)
          this.orderStartDate = "";
          this.orderEndDate = "";
          this.trxnEndDate = "";
          this.trxnStartDate = "";
        });
    },
    fetchallPaymentOptions() {
      this.isLoading = true;
      this.$store.dispatch("config/getActionPrivilege", "Order-View");
      axios
        .get(
          "/PaymentOptions/api/V1.0/PaymentOptions/ViewMerchantPaymentOptions"
        )
        .then((res) => {
          res.paymentOptions.forEach((item) => {
            this.paymentOptions.push({
              value: item.id,
              text: item.name,
            });
          });
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    filterOrders() {
      if (this.trxnDateRange !== "") {
        const [trxnSttDate, trxnEdDate] = this.trxnDateRange.split(" to ");
        // this.trxnEndDate = `${trxnEdDate.trim()}`
        // this.trxnStartDate = `${trxnSttDate.trim()}`

        if (this.trxnDateRange.includes("to")) {
          this.trxnStartDate = trxnSttDate;
          this.trxnEndDate = trxnEdDate;
        } else {
          this.trxnStartDate = this.trxnDateRange;
          this.trxnEndDate = this.trxnDateRange;
        }
      }

      const url = `/Order/api/V1.0/Report/GetTrasactionTrendReport?transactionStartDate=${this.trxnStartDate}&transactionEndDate=${this.trxnEndDate}&paymentOptionId=${this.filterFopId}`;
      // Api call
      this.isLoading = true;
      axios
        .get(url)
        .then((res) => {
          this.dataFiltered = true;
          this.trendReports = res.groupedOrdersReport;
          this.trasactionReport = res.trendReport;
          this.transactionTracker.total = res.trendReport.noOfTransaction;
          this.transactionTracker.successful =
            res.trendReport.noOfSuccessfulTransaction;
          this.transactionTracker.pending =
            res.trendReport.noOfPendingTransaction;
          this.transactionTracker.cancelled =
            res.trendReport.noOfCancelTransaction;
          this.transactionTracker.other = res.trendReport.noOfOtherTransaction;
          this.transactionTracker.transTrackerRadialBar.series[0] =
            res.trendReport.successRate;
          this.sheets[0].data = res.groupedOrdersReport;

          this.isLoading = false;
          this.trxnEndDate = "";
          this.trxnStartDate = "";
        })
        .catch((res) => {
          this.isLoading = false;

          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Error",
              icon: "BellIcon",
              variant: "danger",
              text: `${res.data.message}`,
            },
          });
          // this.$refs.loginForm.setErrors(error)
          this.orderStartDate = "";
          this.orderEndDate = "";
          this.trxnEndDate = "";
          this.trxnStartDate = "";
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@core/scss/base/bootstrap-extended/include";
@import "~@core/scss/base/components/variables-dark";

.card-company-table ::v-deep td .b-avatar.badge-light-company {
  .dark-layout & {
    background: $theme-dark-body-bg !important;
  }
}
</style>
<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>

<style lang="scss">
@import "@core/scss/vue/pages/page-pricing.scss";
</style>
<style lang="scss">
@import "@core/scss/vue/pages/dashboard-ecommerce.scss";
@import "@core/scss/vue/libs/chart-apex.scss";
</style>
